import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setInfoModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import { IProps } from 'components/InfoModal/types';
import Modal from 'components/Modal';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';

const InfoModal: React.FC<IProps> = (props) => {
  const handleConfirm = () => {
    handleClose();
  };

  const handleClose = () => {
    props.setInfoModalVisible(false);
  };

  return (
    <>
      {props.modal.infoModalState.visible && (
        <Modal
          visible={props.modal.infoModalState.visible}
          icon={SweetAlertIcon.Info}
          title={props.modal.infoModalState.title || ''}
          cancelButton={false}
          closeIcon={false}
          onConfirm={handleConfirm}
        >
          <p className="element__part" style={{ fontSize: '18px' }}>{props.modal.infoModalState.content}</p>
        </Modal>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setInfoModalVisible: (visible: boolean, title?:string, content?:string) => dispatch(setInfoModalVisibleAction(visible, title, content))
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoModal);
